import {
  ADD_LEAD_START,
  ADD_LEAD_SUCCESS,
  ADD_LEAD_FAILURE,
  ADD_LEAD_RESET,
  GET_LEAD_START,
  GET_LEAD_SUCCESS,
  GET_LEAD_FAILURE,
  GET_LEAD_RESET,
  DELETE_LEAD_START,
  DELETE_LEAD_SUCCESS,
  DELETE_LEAD_FAILURE,
  DELETE_LEAD_RESET,
  EDIT_LEAD_START,
  EDIT_LEAD_SUCCESS,
  EDIT_LEAD_FAILURE,
  EDIT_LEAD_RESET,
  VIEW_LEAD_START,
  VIEW_LEAD_SUCCESS,
  VIEW_LEAD_FAILURE,
  VIEW_LEAD_RESET,
  CREATE_LEADLOG_START,
  CREATE_LEADLOG_SUCCESS,
  CREATE_LEADLOG_FAILURE,
  CREATE_LEADLOG_RESET,
  CONVERT_LEAD_START,
  CONVERT_LEAD_SUCCESS,
  CONVERT_LEAD_ERROR,
  CLOSE_LEAD_START,
  CLOSE_LEAD_SUCCESS,
  CLOSE_LEAD_FAILURE,
  CLOSE_LEAD_RESET,
  GET_CLOSELEAD_REASON_START,
  GET_CLOSELEAD_REASON_SUCCESS,
  GET_CLOSELEAD_REASON_FAILURE,
  GET_CLOSELEAD_REASON_RESET,
  GET_BLOCKED_LEAD_START,
  GET_BLOCKED_LEAD_SUCCESS,
  GET_BLOCKED_LEAD_FAILURE,
  GET_BLOCKED_LEAD_RESET
} from "./actiontypes"

// add Lead

export const addLeadStart = payload => {
  return {
    type: ADD_LEAD_START,
    payload,
  }
}

export const addLeadSuccess = payload => {
  return {
    type: ADD_LEAD_SUCCESS,
    payload,
  }
}

export const addLeadFailure = error => ({
  type: ADD_LEAD_FAILURE,
  payload: error,
})
export const addLeadReset = () => ({
  type: ADD_LEAD_RESET,
})

// get Lead
export const getLeadStart = payload => ({
  type: GET_LEAD_START,
  payload,
})

export const getLeadSuccess = payload => ({
  type: GET_LEAD_SUCCESS,
  payload,
})

export const getLeadFailure = error => ({
  type: GET_LEAD_FAILURE,
  payload: error,
})
export const getLeadReset = () => ({
  type: GET_LEAD_RESET,
})

// delete Lead

export const deleteLeadStart = phone_no => ({
  type: DELETE_LEAD_START,
  payload: phone_no,
})

export const deleteLeadSuccess = payload => ({
  type: DELETE_LEAD_SUCCESS,
  payload,
})

export const deleteLeadFailure = error => ({
  type: DELETE_LEAD_FAILURE,
  payload: error,
})

export const deleteLeadReset = () => ({
  type: DELETE_LEAD_RESET,
})

// Edit Lead

export const editLeadStart = leadData => ({
  type: EDIT_LEAD_START,
  payload: leadData,
})

export const editLeadSuccess = payload => ({
  type: EDIT_LEAD_SUCCESS,
  payload,
})

export const editLeadFailure = error => ({
  type: EDIT_LEAD_FAILURE,
  payload: error,
})

export const editLeadReset = () => ({
  type: EDIT_LEAD_RESET,
})

//VIEW-LEAD-

export const viewLeadStart = payload => {
  return {
    type: VIEW_LEAD_START,
    payload,
  }
}

export const viewLeadSuccess = payload => {
  return {
    type: VIEW_LEAD_SUCCESS,
    payload,
  }
}

export const viewLeadFailure = error => ({
  type: VIEW_LEAD_FAILURE,
  payload: error,
})
export const viewLeadReset = () => ({
  type: VIEW_LEAD_RESET,
})

//create-lead log

export const createleadlogStart = payload => {
  return {
    type: CREATE_LEADLOG_START,
    payload,
  }
}

export const createleadlogSuccess = payload => {
  return {
    type: CREATE_LEADLOG_SUCCESS,
    payload,
  }
}

export const createleadlogFailure = error => ({
  type: CREATE_LEADLOG_FAILURE,
  payload: error,
})
export const createleadlogReset = () => ({
  type: CREATE_LEADLOG_RESET,
})

export const convertLeadsStart = payload => ({
  type: CONVERT_LEAD_START,
  payload,
})
export const convertLeadsSuccess = payload => ({
  type: CONVERT_LEAD_SUCCESS,
  payload,
})
export const convertLeadsError = payload => ({
  type: CONVERT_LEAD_ERROR,
  payload,
})
export const convertLeadsReset = () => ({
  type: CONVERT_LEAD_ERROR,
})

export const closeLeadStart = payload => ({
  type: CLOSE_LEAD_START,
  payload,
})
export const closeLeadSuccess = payload => ({
  type: CLOSE_LEAD_SUCCESS,
  payload,
})
export const closeLeadFailure = payload => ({
  type: CLOSE_LEAD_FAILURE,
  payload,
})
export const closeLeadReset = () => ({
  type: CLOSE_LEAD_RESET,
})

// get closing lead reason

export const getCloseLeadReasonStart = () => ({
  type: GET_CLOSELEAD_REASON_START,
})

export const getCloseLeadReasonSuccess = payload => ({
  type: GET_CLOSELEAD_REASON_SUCCESS,
  payload,
})

export const getCloseLeadReasonFailure = error => ({
  type: GET_CLOSELEAD_REASON_FAILURE,
  payload: error,
})
export const getCloseLeadReasonReset = () => ({
  type: GET_CLOSELEAD_REASON_RESET,
})


// GET BLOCKED LEADS :
// get Lead
export const getLeadBlockedStart = () => ({
  type: GET_BLOCKED_LEAD_START,
})

export const getLeadBlockedSuccess = payload => ({
  type: GET_BLOCKED_LEAD_SUCCESS,
  payload,
})

export const getLeadBlockedFailure = error => ({
  type: GET_BLOCKED_LEAD_FAILURE,
  payload: error,
})
export const getLeadBlockedReset = () => ({
  type: GET_BLOCKED_LEAD_RESET,
})